exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* Define the proper variables ans redefine Boostrap ones */\n.autocomplete {\n  position: relative; }\n  .autocomplete .autocomplete-list {\n    position: absolute;\n    z-index: 1000;\n    max-height: 300px;\n    overflow-y: auto; }\n", ""]);

